<template>
    <div class="cz__views">
        <image-view :controller="controller" :view="selectedView" @viewSelected="viewSelected"></image-view>
        <div class="cz__view-selector">
            <button v-for="view in views" :key="view.code" :class="['cz__button', 'cz__view', {'cz__view-selected': selectedView != null && view.code === selectedView.code }]" @click="selectView(view)">{{view.name}}</button>
        </div>
    </div>
</template>

<style lang="less">
    .cz__views {
        position: absolute;

        left: 0;
        top: 0;

        width: 100%;
        height: 100%;

        background: #ebebeb;

        @media (min-width: 768px) {
            width: ~"calc(100% - 400px)";
        }
    }

    .cz__image {
        position: absolute;

        left: 0;
        top: 0;

        width: 100%;
        height: 100%;
    }

    .cz__view-selector {
        position: absolute;

        left: 0;
        width: 100%;
        bottom: 100px;

        text-align: center;
    }

    .cz__button.cz__view {
        padding: 0px 15px;

        color: #333;

        background-color: #f1f1f1;

        border: 1px solid transparent;

        &.cz__view-selected {
            position: relative;

            &:after {
                content: '';

                position: absolute;

                left: -1px;
                bottom: -8px;

                width: ~"calc(100% + 2px)";
                height: 3px;

                background: #000;
            }
        }

        &:focus {
            outline: none;
            border: 1px solid #000;
        }

        & + .cz__button.cz__view {
            margin-left: 10px;
        }
    }
</style>

<script>
    import ImageView from './ImageView';

    export default {
        props: {
            controller: Object,
        },
        data() {
            return {
                views: null,
                selectedView: null,
            };
        },
        watch: {
            controller: {
                handler(newValue, oldValue) {
                    this.ensureOptions(newValue, oldValue);
                },
                deep: false,
            },
        },
        mounted() {
            this.ensureOptions(this.controller, this.controller);
        },
        methods: {
            save() {
                this.$emit('save');
            },

            ensureOptions(newValue, oldValue) {
                // Create proxy functions to bind 'this' pointers.
                if (!this.onAfterInitializeBlueprint) {
                    this.onAfterInitializeBlueprint = (state) => { this.initializeBlueprint(state); };
                }

                // Unbind from the old controller.
                if (oldValue) {
                    oldValue.off('afterInitializeBlueprint', this.onAfterInitializeBlueprint);
                }

                if (newValue) {
                    // Listen to events on the new controller.
                    newValue.on('afterInitializeBlueprint', this.onAfterInitializeBlueprint);

                    // If blueprint is already configured (i.e. we missed initializeBlueprint/State events), force the update.
                    if (newValue.blueprintReady) {
                        this.initializeBlueprint({
                            blueprint: newValue.blueprint,
                        });
                    }
                }
            },

            // React to state changes.
            initializeBlueprint(state) {
                // Figure out available (and selected) views.
                this.views = state.blueprint.views.filter(v => !v.hidden);

                if (this.selectedView == null) {
                    if (this.views.length > 0) {
                        ([this.selectedView] = this.views);
                    }
                }
            },

            // Select view.
            selectView(view) {
                this.selectedView = view;
            },

            // Confirms view selection requested by the image controller.
            viewSelected(view) {
                this.selectView(view);
            },
        },
        components: {
            ImageView,
        },
    };
</script>